<template>
  <div class="group flex items-center">
    <img src="/logo-rizome.svg" style="height: 35px;"/>
  </div>
</template>
